module.exports =
  Unsplash:
    DEFAULT_COLLECTION_ID: 317099
    PAGE_SIZE: 18
    RAW_PARAMS: '?w=2560&h=2048&q=90'



// WEBPACK FOOTER //
// ./app/scripts/views/board-create/constants.coffee